import React from 'react'
import { cx } from '../lib/cx'

type Variant = 'primary' | 'ghost'

export function Button<C extends React.ElementType = 'button'>(
  props: {
    as?: C
    variant?: Variant
    size?: 'md' | 'sm'
  } & React.ComponentPropsWithoutRef<C>,
) {
  const { as: Component = 'button', variant = 'primary', size = 'md', className, ...rest } = props
  const base =
    'inline-flex items-center justify-center gap-2 rounded-full font-semibold outline-none transition active:scale-[0.98] disabled:opacity-50 disabled:active:scale-100'
  const sizes = {
    md: 'h-11 px-4 text-[15px]',
    sm: 'h-9 px-3 text-[14px]',
  }
  const variants = {
    primary: 'bg-primary text-white shadow-sm hover:brightness-[0.98] focus-visible:ring-4 focus-visible:ring-primary/25',
    ghost: 'bg-transparent text-ink hover:bg-muted/10 focus-visible:ring-4 focus-visible:ring-muted/15',
  }
  return (
    <Component className={cx(base, sizes[size], variants[variant], className)} {...rest} />
  )
}
